<div class="step-two-col">
  <div class="step-col-main">
    <final-meeting-template></final-meeting-template>
    <date-setted></date-setted>
  </div>
  <div class="step-col-report">
    <report></report>
  </div>
</div>